import React from "react";

/**
 * `IdleWarningModal` — Shown 27 min into an authenticated session with 3
 * minutes of grace before hard logout. Non-dismissable except via the
 * "Stay signed in" button; clicking outside or pressing Esc will NOT
 * dismiss it (deliberate — otherwise stray mousemove events during a
 * device wake-up could silently kill the warning without user intent).
 */
export default function IdleWarningModal({ remainingMs, onStay }) {
    const seconds = Math.max(0, Math.ceil(remainingMs / 1000));
    const mm = String(Math.floor(seconds / 60)).padStart(2, "0");
    const ss = String(seconds % 60).padStart(2, "0");
    return (
        <div
            data-testid="idle-warning-modal"
            className="fixed inset-0 z-[9999] bg-black/60 backdrop-blur-sm flex items-center justify-center px-4"
            role="dialog"
            aria-modal="true"
            aria-labelledby="idle-warning-title"
        >
            <div className="w-full max-w-md bg-white border border-[#E5E5E5] p-6 sm:p-8 shadow-2xl">
                <p className="text-[10px] font-black uppercase tracking-[0.2em] text-[#A3A3A3] mb-3">
                    NaukriDaddy · Session
                </p>
                <h2
                    id="idle-warning-title"
                    className="text-2xl font-bold text-[#0A0A0A] leading-tight mb-2"
                >
                    Are you still there?
                </h2>
                <p className="text-sm text-[#525252] leading-relaxed mb-4">
                    You&apos;ve been inactive for a while. For your security,
                    we&apos;ll sign you out automatically in:
                </p>
                <div
                    data-testid="idle-warning-countdown"
                    className="my-4 py-4 px-5 bg-[#FAFAFA] border-l-4 border-[#B45309] text-center"
                >
                    <p className="font-mono text-4xl font-bold text-[#0A0A0A] tabular-nums leading-none">
                        {mm}:{ss}
                    </p>
                    <p className="text-[10px] font-black uppercase tracking-wider text-[#525252] mt-2">
                        Time remaining
                    </p>
                </div>
                <button
                    type="button"
                    data-testid="idle-warning-stay-btn"
                    onClick={onStay}
                    className="w-full bg-[#0A0A0A] text-white px-5 py-3 text-xs font-bold uppercase tracking-wider hover:bg-[#1F2937] transition-colors"
                >
                    I&apos;m still here — stay signed in
                </button>
                <p className="text-[11px] text-[#A3A3A3] text-center mt-3">
                    Sessions auto-expire after 30 minutes of inactivity.
                </p>
            </div>
        </div>
    );
}
